import { watchGraphQLError } from '@entities/error';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
	yield all([watchGraphQLError()]);
}
